export default [
  {
    position: "absolute",
    top: 19.8,
    left: 40,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "orgChartP2.mTitleOne",
    mBody: "orgChartP2.mBodyOne",
    id: "SP_OrgChart_Chart_Details",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 0.7,
    left: 0.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "recognitionP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_OrgChart_Navigation_Menu",
    index: 1,
  },
  {
    position: "absolute",
    top: 4.8,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "recognitionP2.ttTextSix",
    hover: false,
    id: "SP_OrgChart_Navigation_Communications",
    index: 2,
  },
  {
    position: "absolute",
    top: 4.8,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "recognitionP2.ttTextTwo",
    hover: false,
    id: "SP_OrgChart_Navigation_PayBenefits",
    index: 3,
  },
  {
    position: "absolute",
    top: 4.8,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "recognitionP2.ttTextThree",
    hover: false,
    id: "SP_OrgChart_Navigation_Absence",
    index: 4,
  },
  {
    position: "absolute",
    top: 4.8,
    left: 50.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "recognitionP2.ttTextFour",
    hover: false,
    id: "SP_OrgChart_Navigation_Performance",
    index: 5,
  },
  {
    position: "absolute",
    top: 4.8,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "recognitionP2.ttTextFive",
    hover: false,
    id: "SP_OrgChart_Navigation_Hiring",
    index: 6,
  },
  {
    position: "absolute",
    top: 52,
    left: 7,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-middle-left",
    isDialog: true,
    modal: false,
    mTitle: "recognitionP2.colleagueInformationTitle",
    mBody: "recognitionP2.colleagueInformationBody",
    isVideo: true,
    videoThumb: "SP-Mobile-Org-Thumb",
    videoURL: "SP-Mobile-Org-Chart.mp4",
    vidIcon: true,
    id: "SP_PayBenefits_Video_Colleague_Information",
    index: 7,
  },
];
